import { useMemo, useState } from 'react';

/** Rows drawn at a time in a long list. A list of a few thousand terms drawn
 *  whole is hundreds of thousands of page elements; it is drawn in steps of
 *  this many, with a press for the next step. */
export const SHOWN_ROWS_STEP = 200;

/** The first rows of a long list, and a way to show more. The count grows by
 *  one step per press and is kept while the list changes underneath it. */
export function useShownRows<T>(rows: readonly T[], step: number = SHOWN_ROWS_STEP) {
  const [limit, setLimit] = useState(step);
  const shown = useMemo(() => (rows.length > limit ? rows.slice(0, limit) : rows), [rows, limit]);
  return {
    shown,
    hidden: Math.max(0, rows.length - limit),
    showMore: () => setLimit((l) => l + step),
  };
}
